import { createTheme } from '@mui/material/styles';

// Apple-inspired palette
export const colors = {
  ink: '#1d1d1f',
  inkSoft: '#6e6e73',
  white: '#ffffff',
  offwhite: '#fbfbfd',
  gray: '#f5f5f7',
  grayBorder: '#d2d2d7',
  black: '#000000',
  nearBlack: '#101014',
  blue: '#0071e3',
  blueDark: '#0058b8',
};

const fontFamily = [
  '-apple-system',
  'BlinkMacSystemFont',
  '"SF Pro Display"',
  '"SF Pro Text"',
  '"Inter"',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
].join(',');

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: colors.blue, dark: colors.blueDark, contrastText: '#fff' },
    background: { default: colors.white, paper: colors.offwhite },
    text: { primary: colors.ink, secondary: colors.inkSoft },
    divider: colors.grayBorder,
  },
  shape: { borderRadius: 18 },
  typography: {
    fontFamily,
    h1: {
      fontWeight: 700,
      letterSpacing: '-0.03em',
      lineHeight: 1.03,
      fontSize: 'clamp(2.75rem, 7vw, 6rem)',
    },
    h2: {
      fontWeight: 700,
      letterSpacing: '-0.03em',
      lineHeight: 1.06,
      fontSize: 'clamp(2rem, 5vw, 3.75rem)',
    },
    h3: {
      fontWeight: 600,
      letterSpacing: '-0.02em',
      lineHeight: 1.1,
      fontSize: 'clamp(1.6rem, 3.5vw, 2.5rem)',
    },
    h4: { fontWeight: 600, letterSpacing: '-0.02em' },
    h5: { fontWeight: 600, letterSpacing: '-0.01em' },
    h6: { fontWeight: 600 },
    subtitle1: { fontSize: '1.35rem', fontWeight: 400, lineHeight: 1.4 },
    body1: { fontSize: '1.0625rem', lineHeight: 1.55 },
    body2: { fontSize: '0.95rem', lineHeight: 1.5 },
    button: { textTransform: 'none', fontWeight: 500 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 980, paddingInline: 22, paddingBlock: 10, fontSize: '1.02rem' },
        containedPrimary: {
          backgroundColor: colors.blue,
          '&:hover': { backgroundColor: colors.blueDark },
        },
      },
    },
    MuiContainer: { defaultProps: { maxWidth: 'lg' } },
    MuiCssBaseline: {
      styleOverrides: {
        html: { scrollBehavior: 'smooth', WebkitFontSmoothing: 'antialiased' },
        body: { backgroundColor: colors.white, overflowX: 'hidden' },
        '@media (prefers-reduced-motion: reduce)': {
          html: { scrollBehavior: 'auto' },
        },
      },
    },
  },
});

export default theme;
